<template>
  <v-app class="white" style="padding-left: 55px;">
    <core-drawer />

    <v-system-bar
      v-if="enviroment.name == 'staging'"
      dark
      color="red"
      height="40"
      class="justify-center">
      HOMOLOGAÇÃO
    </v-system-bar>

    <alert-banner />

    <v-progress-linear
      :indeterminate="isLoading"
      :query="isLoading"
      background-color="#eee"
      color="primary"
      size="20"
      height="2"
      style="margin: 0; position: absolute; top: 0; left: 0"
      width="1"></v-progress-linear>
    <core-view />
  </v-app>
</template>

<script>
/* eslint-disable no-console */

import { mapState } from "vuex";
import UserService from "@/services/user";
import enviroment from "@/enviroment";
import AlertBanner from "@/components/AlertBanner.vue";

export default {
  name: "App",
  components: {
    AlertBanner
  },
  data() {
    return {
      enviroment: enviroment,
      user: null,
    };
  },
  computed: {
    ...mapState(["isLoading", "refCount"]),
  },
  methods: {
    onTokenRegistered(token) {
      this.$store.commit("setFCMToken", token);

      if (this.$store.getters.getLoggedUser) {
        UserService.registerGcmToken(token).then(
          function () {
            console.debug("Token GCM registrado para usuário atual");
          },
          function (error) {
            console.debug("Erro ao registrar token GCM", error);
          }
        );
      }
    },
  },
  created() {
    console.debug("Versao:", this.$store.getters.appVersion);
  },
};
</script>

<style lang="scss">
@import "@/styles/index.scss";
@import url("https://cdn.jsdelivr.net/npm/md-date-range-picker@0.8.4/dist/md-date-range-picker.min.css");
.v-sheet {
  border-radius: 4px !important;
}
.tag-approach-type {
  padding: 6px 4px;
  color: white;
  margin-right: 2px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
}

.small {
  font-size: 10px;
}

.SMS,
.INCENTIVE_SMS {
  background-color: #3f51b5;
}

.SMS_FLASH,
.INCENTIVE_FLASH {
  background-color: #2e86c1;
}

.EMAIL,
.INCENTIVE_EMAIL {
  background-color: orange;
}

.EMAIL_TEXT,
.INCENTIVE_EMAIL_TEXT {
  background-color: #e74c3c;
}

.PUSH,
.INCENTIVE_PUSH {
  background-color: teal;
}

.VOICE_MESSAGE,
.INCENTIVE_VOICE_MESSAGE {
  background-color: purple;
}

.VOICE_CALL,
.INCENTIVE_VOICE_CALL {
  background-color: goldenrod;
}

.CALL_PHONE,
.INCENTIVE_CALL_PHONE {
  background-color: #004d40;
}

.CALL_CELLPHONE,
.INCENTIVE_CALL_CELLPHONE {
  background-color: #007327;
}

.WHATSAPP,
.INCENTIVE_WHATSAPP {
  background-color: #535a11;
}

.INCENTIVE_PUSH {
  background-color: #c2185b;
}

.INCENTIVE_SMS {
  background-color: #6d4c41;
}

.INCENTIVE_WHATSAPP {
  background-color: #143f0a;
}

.INCENTIVE_EMAIL {
  background-color: #880e4f;
}

/* INÍCIO DATA TABLE */
table.v-table tbody td:first-child,
table.v-table tbody td:not(:first-child),
table.v-table tbody th:first-child,
table.v-table tbody th:not(:first-child),
table.v-table thead td:first-child,
table.v-table thead td:not(:first-child),
table.v-table thead th:first-child,
table.v-table thead th:not(:first-child),
table.v-table tfoot tr td {
  padding: 0 10px !important;
}
.v-table tbody td,
table.v-table tbody th {
  height: 52px !important;
}
/* FIM DATA TABLE */

/* INÍCIO DATA PICKER */

table.calendar-table td.calendar-cell.in-range[data-v-89ba891e] {
  background-color: #daedfd !important;
}
.ranges li[data-v-4e185066]:hover {
  background-color: #ececec !important;
  border-radius: 0 25px 25px 0 !important;
}
.mdrp__activator .activator-wrapper .text-field {
  cursor: pointer;
  width: 100% !important;
  height: 56px;
  line-height: 20px;
  font-size: 16px !important;
  padding: 8px 0 8px !important;
  text-align: center;
  font-weight: bold;
  border-bottom: 2px solid #512dab !important;
}
thead .month {
  font-size: 16px !important;
}
.calendar-table.calendar.right .month {
  padding-right: 60px !important;
}
.v-drp__css-icon-wrapper .v-drp__css-icon.arrow-left[data-v-89ba891e]:before,
.v-drp__css-icon-wrapper .v-drp__css-icon.arrow-right[data-v-89ba891e]:before {
  top: 13px !important;
}
.calendar-table.calendar.left .next,
.calendar-table.calendar.right .prev {
  display: none !important;
}
.calendar-table.calendar.right thead {
  float: right !important;
}
.ranges[data-v-4e185066] ul li {
  font-size: 14px !important;
}
.mdrp-root[data-v-7863e830] {
  margin-bottom: 8px !important;
  background: rgba(0, 0, 0, 0.06);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  -webkit-transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
.mdrp-root[data-v-7863e830]:hover {
  background: rgba(0, 0, 0, 0.12);
}
.mdrp__activator .activator-wrapper .text-field__filled ~ label {
  font-size: 16px !important;
  color: #512dab !important;
  font-weight: bold !important;
  left: 0px !important;
  display: none;
}
.mdrp__activator .activator-wrapper .bar:after,
.mdrp__activator .activator-wrapper .bar:before {
  background: #512dab !important;
  bottom: 0px !important;
}
.mdrp-root[data-v-7863e830],
.mdrp__activator .activator-wrapper .bar {
  width: 100% !important;
}
.mdrp__panel.opens-arrow-pos-right[data-v-7863e830] {
  top: 55px !important;
}
/* FIM DATA PUCKER */
.v-messages__message {
  line-height: 12px !important;
}

.v-toolbar__content {
  height: initial !important;
}

.text-details-none.v-text-field .v-text-field__details,
.v-messages-none .v-messages {
  display: none;
}
.text-details-none.v-text-field .v-input__control .v-input__slot {
  margin: 0;
}

/* helpers */
.truncate {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

strong {
  font-size: 14px;
}

p {
  padding: 0 !important;
  margin: 0 !important;
  font-size: 13px !important;
}

td p {
  line-height: normal;
  padding: 2px 0;
}

.v-datatable__actions__range-controls {
  margin-right: 8%;
}

.v-input--selection-controls__input {
  margin: 0 !important;
}

.chip-incentive-step {
  padding: 6px 4px;
  color: white;
  margin-right: 2px;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
}

.PROPOSAL_SELECTED {
  background-color: #3f51b5;
}

.LANDING_ACCESSED {
  background-color: #007327;
}

.LINK_ACCESSED {
  background-color: #004d40;
}

.LOGGED_IN {
  background-color: goldenrod;
}

.SYNC_RESOLVED {
  background-color: purple;
}
</style>
